<template>
  <section id="partner-order-detail">
    <div v-if="loadingOrder" class="loading-container">
      <img src="@shared/assets/img/general/loading.svg" alt="loading" />
    </div>
    <div v-else class="content-container">
      <div class="top-container">
        <div class="top">
          <div class="h-left-container">
            <div class="header">
              {{ header }}
            </div>
          </div>
        </div>
      </div>
      <div class="body-container">
        <div class="content-container flex-row align-start">
          <div class="flex-column-1 margin-right-8">
            <CompanyInformation />
            <div class="flex-row-1 margin-bottom-8">
              <BillingInformation />
              <ShippingInformation />
            </div>
            <OrderComplete v-if="paymentPending" />
            <InvoicePaymentMethod v-if="invoicePaymentMethod" />
          </div>
          <div class="flex-column-1">
            <OrderSubscription />
            <OrderHardware />
            <OrderTotal />
          </div>
        </div>
      </div>
    </div>
    <ActionModal />
    <OrderProcessingOverlay
      :show="processingOrder || processingDirectDebit"
      :header="processingDirectDebit ? '' : 'Processing Your Invoice'"
    />
  </section>
</template>

<script>
import ActionModal from '@shared/components/partnerReview/ActionModal.vue';
import CompanyInformation from '@shared/components/partnerReview/CompanyInformation.vue';
import BillingInformation from '@shared/components/partnerReview/BillingInformation.vue';
import ShippingInformation from '@shared/components/partnerReview/ShippingInformation.vue';
import OrderSubscription from '@shared/components/partnerReview/OrderSubscription.vue';
import OrderHardware from '@shared/components/partnerReview/OrderHardware.vue';
import OrderTotal from '@shared/components/partnerReview/OrderTotal.vue';
import OrderComplete from '@shared/components/partnerReview/OrderComplete.vue';
import InvoicePaymentMethod from '@shared/components/partnerReview/InvoicePaymentMethod.vue';
import OrderProcessingOverlay from '@shared/components/shared/billingModal/OrderProcessingOverlay.vue';
import partnerReviewMixin from '@shared/mixins/partnerReviewMixin';

export default {
  name: 'PartnerOrderReview',
  components: {
    CompanyInformation,
    BillingInformation,
    ShippingInformation,
    OrderHardware,
    OrderSubscription,
    OrderTotal,
    OrderComplete,
    InvoicePaymentMethod,
    OrderProcessingOverlay,
    ActionModal,
  },
  mixins: [partnerReviewMixin],
  data() {
    return {
      header: '',
    };
  },
  watch: {
    order(nOrder) {
      if (
        nOrder.billingAddress &&
        nOrder.billingAddress.state &&
        nOrder.billingAddress.zip &&
        nOrder.billingAddress.country
      ) {
        this.$store.dispatch('getPartnerOrderReviewTax');
      }
    },
  },
  mounted() {
    this.handleMounted();
  },
  methods: {
    async loadingPdf() {
      const { AGREEMENT_CONTRACT_PDF = '' } = this.partnerSettings;
      if (AGREEMENT_CONTRACT_PDF !== '') {
        const pdfFile = await this.$store.dispatch('getContractResponse', {
          url: AGREEMENT_CONTRACT_PDF,
        });
        this.changePartnerReviewValue('pdfFile', pdfFile);
      }
    },
    async handleMounted() {
      const { orderNumber } = this.$route.params;

      this.header = `Partner Order #${orderNumber} Review`;

      const res = await this.$store.dispatch('getPartnerOrderReview', { orderNumber });
      if (res) {
        this.$store.dispatch('getPartnerOrderReviewTax');
        this.$store.dispatch('getPartnerPaymentMethod');
        if (Object.keys(this.partnerSettings).length === 0) {
          this.$store.dispatch('getPartnerDetail', { corpId: this.order.corporation.id });
          this.loadingPdf();
        }
      } else {
        this.$router.push('/not-found');
      }
    },
  },
};
</script>

<style lang="scss">
section#partner-order-detail {
  display: flex;
  flex: 1;
  flex-direction: column;

  .loading-container {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .content-container {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .top-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 25px 100px 32px 100px;
    background-color: $BLACK;

    .top {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin-bottom: 0;
      max-width: 1705px;
      width: 100%;

      .h-left-container {
        .header {
          font-size: 28.83px;
          color: $WHITE;
          margin-bottom: 8px;
        }

        .sub-header {
          font-size: 14.42px;
          font-weight: 500;
          color: $WHITE;
        }
      }
    }
  }

  .od-card-container {
    border-radius: 8px;
    background-color: $WHITE;
    position: relative;

    .odc-header-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px;
      background-color: $CONTENTGRAY;
      border-top-right-radius: 6px;
      border-top-left-radius: 6px;

      .odc-header {
        font-size: 1.125rem;
        font-weight: 500;
        color: $WHITE;
      }

      .edit-btn {
        color: $WHITE;
        font-size: 1rem;
        font-weight: 600;
        border: 1px solid;
        border-radius: 5px;
        padding: 0 10px;
      }
    }

    .odc-body-container {
      padding: 16px;
      max-height: 600px;
      overflow: auto;

      .odc-loading-container {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 48px;
      }

      .odcb-info-container:not(:last-child) {
        margin-bottom: 8px;
      }

      .odcb-header {
        font-size: 1rem;
        color: $N100;
        font-weight: 500;
      }

      .odcb-body {
        font-size: 1rem;
        color: $N100;
      }

      .odcb-border-container {
        padding-top: 8px;
        padding-bottom: 8px;

        &:first-child {
          padding-top: 0;
        }

        &:last-child {
          padding-bottom: 0;
        }

        &:not(:last-child) {
          border-bottom: 1px solid $N10;
        }

        .odcb-shipping-container {
          width: 25%;
        }
      }

      .odcb-button-container {
        margin-top: 12px;

        .odcb-btn {
          width: 100%;
          background-color: $NBLUE100;
          height: 40px;
          border-radius: 4px;
          color: $WHITE;
          font-weight: 500;
        }
      }

      .card-img {
        height: 35px;
      }
    }
  }

  .green-dot {
    background-color: $BASIL100;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    margin-right: 12px;
    display: block;
  }

  .red-dot {
    background-color: $TOMATO100;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    margin-right: 12px;
    display: block;
  }

  .yellow-dot {
    background-color: $SUNSET100;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    margin-right: 12px;
    display: block;
  }

  .error-status {
    width: 8px;
    margin-right: 12px;
    text-align: center;
    color: $TOMATO100;
    font-weight: 700;
    font-size: 1rem;
    transform: scale(1.2);
  }

  .cancelled-status {
    width: 8px;
    margin-right: 12px;
    text-align: center;
    color: $BLACK;
    font-weight: 700;
    font-size: 1rem;
    transform: scale(1.2);
  }

  .body-container {
    flex: 1;
    background-color: $NAVY100;
    padding: 40px 100px 70px 100px;
    display: flex;
    justify-content: center;

    .content-container {
      display: flex;
      flex-direction: column;
      max-width: 1705px;
      width: 100%;
    }

    .bc-top-container {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      height: 48px;

      .bc-top-button {
        padding: 8px 16px;
        background-color: $NBLUE100;
        color: $WHITE;
        border-radius: 6px;
        font-weight: 500;
      }
    }

    .b-row-container {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      margin-top: 24px;
      max-width: 1705px;
      width: 100%;

      .b-card-container {
        margin-top: 0;

        &:last-child {
          margin-left: 24px;
        }
      }

      .bi-body {
        margin-top: 12px;
        font-size: 1rem;
        color: $N100;
      }
    }

    .body-row {
      display: flex;
      align-items: center;
    }

    .b-card-container {
      width: 100%;
      overflow: auto;
      border-radius: 8px;
      background-color: $WHITE;
      margin-top: 24px;
      position: relative;
      padding-bottom: 16px;
      max-width: 1705px;
      width: 100%;

      &.no-overflow {
        overflow: unset;
      }

      &.error {
        border: 1px solid $TOMATO100;
      }

      .bc-header-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: sticky;
        padding: 16px;
        top: 0;
        background-color: $CONTENTGRAY;
        border-top-right-radius: 6px;
        border-top-left-radius: 6px;

        &.no-border-radius {
          border-radius: 0;
        }

        .bc-header-radio-container {
          display: flex;

          .bc-radio-container {
            display: flex;
            align-items: center;
            margin-left: 24px;

            label {
              margin-left: 6px;
              color: $WHITE;
            }
          }
        }

        .bc-button-container {
          display: flex;

          .cancel-btn {
            color: $WHITE;
            font-size: 1rem;
            font-weight: 600;
            cursor: pointer;
            margin-right: 12px;
          }

          .edit-btn {
            color: $WHITE;
            font-size: 1rem;
            font-weight: 600;
            cursor: pointer;
            border: 1px solid;
            border-radius: 5px;
            padding: 0 10px;
          }

          .save-btn {
            width: 80px;
            height: 30px;
            background-color: $NBLUE100;
            color: $WHITE;
            border-radius: 8px;
            font-weight: 500;
            margin-left: 12px;
          }
        }
      }

      .bi-body-container {
        padding: 0 15px;
      }

      .bc-header {
        font-size: 1rem;
        font-weight: 500;
        color: $WHITE;
      }

      .bc-line-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 12px;
        padding: 0 15px;

        .bl-header {
          font-size: 1rem;
          font-weight: 500;
          color: $N100;

          &:first-child {
            width: 40%;
          }

          &:nth-child(2) {
            width: 10%;
            text-align: center;
          }

          &:nth-child(3) {
            width: 10%;
            text-align: center;
          }

          &:nth-child(4) {
            width: 10%;
            text-align: center;
          }

          &:nth-child(5) {
            width: 30%;
            text-align: right;
          }

          &.error {
            &:first-child {
              width: 30%;
            }

            &:nth-child(2) {
              width: 50%;
              text-align: center;
            }

            &:nth-child(3) {
              width: 20%;
              text-align: center;
            }
          }
        }

        .bl-body {
          font-size: 1rem;
          color: $N100;

          &.input-container {
            margin-top: 0;
          }

          &:first-child {
            width: 40%;
          }

          &:nth-child(2) {
            width: 10%;
            text-align: center;
          }

          &:nth-child(3) {
            width: 10%;
            text-align: center;
          }

          &:nth-child(4) {
            width: 10%;
            text-align: center;
          }

          &:nth-child(5) {
            width: 30%;
            text-align: right;
          }

          &.error {
            &:first-child {
              width: 30%;
            }

            &:nth-child(2) {
              width: 50%;
              text-align: center;
            }

            &:nth-child(3) {
              width: 20%;
              text-align: center;
            }
          }
        }
      }

      .bs-line-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 12px;
        padding: 0 15px;

        .bs-header {
          font-size: 1rem;
          font-weight: 500;
          color: $N100;
          flex: 1;

          &:not(:first-child) {
            margin-left: 16px;
            text-align: center;
          }

          &:last-child {
            text-align: right;
          }
        }

        .bs-body {
          font-size: 1rem;
          color: $N100;
          flex: 1;

          &:not(:first-child) {
            margin-left: 16px;
            text-align: center;
          }

          &.input-container {
            margin-top: 0;
          }

          &:last-child {
            text-align: right;
          }
        }

        .bs-info-header {
          font-size: 1rem;
          font-weight: 500;
          color: $N100;
        }
      }

      .bs-button-container {
        margin-top: 12px;
        margin-bottom: 16px;

        .edit-btn {
          width: 120px;
          height: 28px;
          background-color: $NBLUE100;
          border-radius: 8px;
          color: $WHITE;
          font-weight: 500;
        }
      }

      .bo-row-container {
        display: flex;
        justify-content: space-between;
        margin-top: 12px;

        .bo-body-container {
          display: flex;
          flex-direction: column;
          flex: 1;

          &.center {
            align-items: center;
          }

          &:last-child {
            align-items: flex-end;
          }

          .bo-header {
            font-size: 1rem;
            color: $N100;
            font-weight: 500;
          }

          .input-container {
            margin-top: 0;
          }

          .fulfill-btn {
            width: 80px;
            height: 30px;
            background-color: $NBLUE100;
            color: $WHITE;
            border-radius: 8px;
            font-weight: 500;
          }
        }
      }

      .input-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .checkbox-container {
        display: flex;
        width: 100%;
        align-items: center;
        margin-top: 12px;

        input {
          position: initial;
          opacity: 1;
        }

        label {
          margin-left: 12px;
        }
      }

      .input-container {
        display: flex;
        flex-direction: column;
        margin-top: 12px;
        width: 50%;

        &.two {
          width: 49%;
        }

        &.three {
          width: 32%;
        }

        input,
        select {
          height: 48px;
          border: 1px solid $MEDIUMGRAY;
          border-radius: 8px;
          padding-left: 12px;
          width: 100%;

          &::placeholder {
            color: $N30;
          }

          &.placeholder {
            color: $N30;
          }
        }
      }

      .bc-row-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 0 15px;

        .bc-info-container {
          width: 48%;
          display: flex;
          margin-top: 12px;
          align-items: center;
          justify-content: space-between;

          .bi-body {
            font-size: 1rem;
            color: $N100;
          }

          .p-input {
            height: 38px;
            border-radius: 4px;
            border: 1px solid $N20;
            padding: 0 10px;
          }
        }
      }

      .b-button-container {
        margin-top: 12px;
        display: flex;
        align-items: center;
        justify-content: center;

        .save-btn {
          width: 120px;
          height: 36px;
          font-size: 1rem;
          color: $WHITE;
          border-radius: 8px;
          font-weight: 500;
          background-color: $NBLUE90;
        }
      }
    }

    .error {
      font-size: 0.75rem;
      color: $TOMATO100;
    }

    .back-container {
      display: flex;
      padding: 5px;
      background-color: $CONTENTGRAY;
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;

      .back-btn {
        display: flex;
        align-items: center;

        .arrow-left {
          height: 18px;
          margin-right: 8px;
        }

        span {
          font-size: 1rem;
          color: $WHITE;
          font-weight: 500;
        }
      }
    }
  }

  .page-not-found {
    bottom: 0;
    left: 0;
    margin: auto;
    max-height: 100%;
    max-width: 100%;
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>
